import {
	Component,
	OnInit,
	Input,
	Output,
	HostBinding,
	EventEmitter,
	ViewEncapsulation,
	HostListener,
	OnDestroy
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";

@Component({
	selector: "rbc-menu-item",
	template: `
		<span
			[id]="id"
			[attr.aria-hidden]= "divider"
			[attr.role]= "divider ? 'none' : 'menuitem'"
		>
			<ng-container *ngIf="!divider">
				<!-- Option 1 -->
				<a
					*ngIf="router"
					[id]="id+'LinkButton'"
					[routerLink]= "routerTo"
					routerLinkActive="active"
					class= "rbc-menu-link router-link-active"
				>
					<ng-container
						*ngTemplateOutlet="iconContent"
					></ng-container>
				</a>

				<!-- Option 2 -->
				<a
					*ngIf="!router && href"
					[id]="id+'LinkButton'"
					class="rbc-menu-link"
					[target]="target"
					[href]="href"
				>

					<ng-container
						*ngTemplateOutlet="iconContent"
					></ng-container>
				</a>

				<!-- Option 3 -->
				<button
					*ngIf="!router && !href"
					[id]="id+'LinkButton'"
					class="rbc-menu-link"
				>
					<ng-container
						*ngTemplateOutlet="iconContent"
					></ng-container>
				</button>
			</ng-container>
			<ng-template #iconContent>
				<rbc-icon
					*ngIf="icon"
					[icon]="icon"
					[type]="iconWeight"
					class="rbc-menu-item-icon"
				></rbc-icon>
				<ng-content></ng-content>
			</ng-template>
		</span>
	`,
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class MenuItemComponent implements OnInit, OnDestroy {
	@Input() href: string;
	link: string;
	@Input() divider: boolean;
	@Input() icon: string;
	@Input() iconWeight: string;
	@Input() router: boolean;
	@Input() routerTo: string;
	@Input() routeObject: string;

	@Input() target = "_blank";
	@Input() id: string;

	@Output() clickEvent = new EventEmitter();

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	@HostBinding("class") @Input("class") classList = "";
	@HostListener("click", ["$event"]) onClick(e) {
		this.clickHandler(e);
	}

	ngOnInit() {
		this.link = this.href ? this.href : null;
		this.classList = [
			this.classList,
			"rbc-menu-item",
			this.divider ? "rbc-menu-divider" : null
		]
			.filter(i => !!i)
			.join(" ");
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	clickHandler(e) {
		this.clickEvent.emit(e);
	}

}
